import { locale } from '@/locales'

export const commonStrings = {
  copyToastMessage: locale.copyToast.copiedToClipboard,
} as const
